// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"74d1d659","363":"8d686aa5","378":"e89fe64c"}[chunkId] + ".chunk.css";
};